var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var initializeModules = require( './lib/init-modules.js' );
var Header = require( '../../modules/header/header.js' );
var MainMenu = require( '../../modules/main-menu/main-menu.js' );
var ModuleVideo = require( '../../modules/module-video/module-video.js' );
var ModuleFAQ = require( '../../modules/module-faq/module-faq.js' );
var ModuleOrderForm = require( '../../modules/module-order-form/module-order-form.js' );
var ModuleOrderForm2Step = require( '../../modules/module-order-form-2-step/module-order-form-2-step.js' );
var ModuleMediaFixed = require( '../../modules/module-media-fixed/module-media-fixed.js' );
var ModuleMediaFluid = require( '../../modules/module-media-fluid/module-media-fluid.js' );
var PopUp = require( '../../modules/pop-up/pop-up.js' );
var CustomFormValidator = require( './lib/custom-form-validator.js' );

$(
    function () {

          initializeModules();

          var $window = $( window );

          var init = function () {
                Header.init();
                MainMenu.init();
                ModuleVideo.init();
                ModuleFAQ.init();
                ModuleOrderForm.init();
                ModuleOrderForm2Step.init();
                ModuleMediaFixed.init();
                ModuleMediaFluid.init();
                PopUp.init();

                $.fn.scrollToInit();

          };

          $( document ).on(
              'ready', function () {

                    init();

                    $( document ).foundation();

                    CustomFormValidator.addCustomValidations( ModuleOrderForm.$orderForm );
                    CustomFormValidator.noEmptyFields( ModuleOrderForm.$orderForm );
                    CustomFormValidator.addCustomValidations( ModuleOrderForm2Step.$orderForm );
                    CustomFormValidator.noEmptyFields( ModuleOrderForm2Step.$orderForm );

                    CustomFormValidator.zipLookup( ModuleOrderForm );
                    CustomFormValidator.zipLookup( ModuleOrderForm2Step );

              }
          );

          /**
           * Get the height of the header bar.
           * @returns {jQuery}
           */
          $.fn.getHeaderHeight = function ( number ) {
                if ( !number ) {
                      number = 0;
                }
                return $( '.header__inner' ).outerHeight() + number;
          };

          /**
           * Scroll initially after page load.
           */
          $.fn.scrollToInit = function () {

                // Menu item click event.
                $( 'a' ).click( function ( e ) {

                      var obj = $( this ),
                          id = obj.get( 0 ).hash.replace( 'scroll-', '' ),
                          target_element = $( id ),
                          is_current_page = obj.get( 0 ).pathname === window.location.pathname;

                      // Check if we are on the same page that the link points to
                      // Check if we found an element corresponding with an ID corresponding to our hash on the link
                      if ( is_current_page && target_element.length ) {

                            // Close menu when click on a menu link if the menu is open
                            $( 'a.header__menu-toggle.is-active' ).click();

                            // Check if is adminbar and add extra-height. If not, add 0.
                            var headerHeightAdd = (document.getElementById('wpadminbar') !== null) ? 32 : 0;

                            // Scroll to element
                            $( 'html, body' ).animate( {
                                  scrollTop: ( target_element.offset().top - $.fn.getHeaderHeight( headerHeightAdd ) )
                            }, 750 );

                            // Stop native behaviour
                            e.preventDefault();
                            return false;

                      }

                      // Proceed like normal
                      return true;

                } );

                /**
                 * Scroll down to target element if we have one.
                 */
                setTimeout( function () {
                      // Check if we have a hash in the URL
                      var hash = window.location.hash.replace( '#', '' ).replace( 'scroll-', '' );
                      if ( hash ) {

                            // Look for an element corresponding to that ID
                            var id = '#' + hash,
                                el = $( id );
                            var headerHeightAdd = (document.getElementById('wpadminbar') !== null) ? 32 : 0;
                            if ( el.length ) {

                                  // Scroll to element
                                  $( 'html, body' ).animate( {
                                        scrollTop: ( el.offset().top - $.fn.getHeaderHeight( headerHeightAdd ) )
                                  }, 750 );

                            }
                      }
                }, 1000 );

          };

          $window.on(
              'load', function () {

              }
          );

          $window.on(
              'resize', function () {
                    Foundation.reInit( $( '[data-equalizer]' ) );
              }
          );

    }
);
